export default "__VITE_ASSET__585f601e__"